module.exports = __webpack_public_path__ + "static/media/Picture1logo.cd862bbd.png";